import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/logo-top.png';
const _withScopeId = n => (_pushScopeId("data-v-334a2c93"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "padding-left": "10px"
  },
  alt: ""
})], -1));
const _hoisted_3 = {
  class: "header-top"
};
import { reactive, onMounted, watch } from 'vue';
import router from "@/router";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const data = reactive({
      menu: [{
        label: '首页',
        value: '/'
      }, {
        label: '公司介绍',
        value: '/company'
      }, {
        label: '产品介绍',
        value: '/product'
      }, {
        label: '加入我们',
        value: '/join'
      }],
      active: '/'
    });
    watch(() => {
      data.active = router.currentRoute.value.path;
    });
    onMounted(() => {
      data.active = router.currentRoute.value.path;
    });
    const selectTab = tab => {
      data.active = tab;
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.menu, (item, index) => {
        return _openBlock(), _createBlock(_component_router_link, {
          to: item.value,
          key: index,
          class: _normalizeClass({
            'active': data.active === item.value
          }),
          onClick: $event => selectTab(item.value)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
          _: 2
        }, 1032, ["to", "class", "onClick"]);
      }), 128))])]);
    };
  }
});